import styled from '@emotion/styled';
import {colors} from "patient-ping-remedy/packages/theme";
import {css} from "@emotion/react";

const RightColumn = styled.div`
    grid-area: right-column;
`;

const LeftColumn = styled.div`
    grid-area: left-column;
`;

const LeftColumnContent = styled.div`
    border: 1px solid ${colors.gray2};
    border-radius: 8px;
    padding: 20px;
    background-color: ${colors.white};
`;

const RightColumnContent = styled.div`
    padding: 20px;
    border: 1px solid ${colors.gray2};
    border-radius: 8px;
    background-color: ${colors.white};
`;

const Container = styled.div(
  css`
      display: grid;
      grid-template-areas:
  "left-column right-column";
      grid-template-rows: 1fr;
      grid-template-columns: 1fr 1fr; 
      grid-row-gap: 0;
      grid-column-gap: 40px;
      width: 100%;

      @media (max-width: 1050px) {
          grid-template-areas:
    "right-column"
    "left-column";
          grid-template-rows: min-content 1fr;
          grid-template-columns: 1fr; 
      }
`);

export { RightColumn, LeftColumn, LeftColumnContent, RightColumnContent, Container};
